import { Asterisk } from "lucide-react";
import { SERVICES } from "../../data/services";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {SERVICES.map((s) => (
      <span key={s.slug} className="flex items-center">
        <span className="px-6 font-display text-5xl font-extrabold uppercase tracking-tight md:text-7xl">{s.short}</span>
        <Asterisk className="h-8 w-8 md:h-10 md:w-10" strokeWidth={2.5} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section aria-label="Our services" className="marquee-wrap relative overflow-hidden bg-[var(--signal)] py-6 text-[var(--ink)]" data-testid="services-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
